<template>
  <div>
    <p class="localitie ma-0">{{ localitie }}</p>
    <p class="ma-0">
      <span class="treatmentNumber mr-2">{{ treatmentNumber }}</span>
      <span class="legend">Atendimentos</span>
    </p>
  </div>
</template>

<script>
export default {
  props: {
    localitie: {
      type: String,
      required: true
    },
    treatmentNumber: {
      type: Number,
      required: true
    }
  }
};
</script>

<style scoped>
.localitie {
  font-family: "Montserrat", sans-serif;
  font-weight: 500;
  font-size: 14px;
  line-height: 24px;
  letter-spacing: 0.16px;
  font-feature-settings: "pnum" on, "lnum" on;
  color: #000000;
}

.treatmentNumber {
  font-family: "Montserrat", sans-serif;
  font-weight: 500;
  font-size: 14px;
  line-height: 24px;
  letter-spacing: 0.16px;
  font-feature-settings: "pnum" on, "lnum" on;
  color: #0012a6;
}

.legend {
  font-family: "Montserrat", sans-serif;
  font-size: 12px;
  line-height: 20px;
  text-align: center;
  letter-spacing: 0.32px;
  font-feature-settings: "pnum" on, "lnum" on;
  color: #616161;
}
</style>